import { render } from "./ChooseVariantsModal.vue?vue&type=template&id=9caffeac&scoped=true"
import script from "./ChooseVariantsModal.vue?vue&type=script&lang=ts"
export * from "./ChooseVariantsModal.vue?vue&type=script&lang=ts"

import "./ChooseVariantsModal.vue?vue&type=style&index=0&id=9caffeac&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-9caffeac"

export default script